
import "./schedule.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useState, useEffect, useTransition, useRef } from "react";
import React from "react";

/* banco de dados */
import { db, auth } from "../../services/firebaseConnection";
import { getDoc, doc, collection, query, where, orderBy, getDocs, onSnapshot, updateDoc, deleteField } from "firebase/firestore";

/* funções auxiliares */
import { db_basic, wait } from "../../services/functions/functions.ts";

/* links */
import { Link, useNavigate } from "react-router-dom";

/* ícones */
import { CalendarCheck, CalendarClock, CalendarX, CalendarSync, ArrowBigRightDash, ArrowBigLeftDash, ClockArrowUp } from "lucide-react";


export default function Schedule() {

    const [basic, setBasic] = useState([]);
    const [mondayBase, setMondayBase] = useState(normalizeMonday(getWeekRange().monday));
    const [mondayStart, setMondayStart] = useState(null);
    const [mondayEnd, setMondayEnd] = useState(null);

    const [semana, setSemana] = useState([]);
    const [hoverAgendamento, setHoverAgendamento] = useState(null);
    const [intervalSemana, setIntervalSemana] = useState(60);

    const [isUpdating, setIsUpdating] = useState(false);
    const [erroAcao, setErroAcao] = useState("");
    const [erroNavegar, setErroNavegar] = useState("");

    const navigate = useNavigate();

    const HORAS_UI = gerarHorasUI(intervalSemana);

    const tooltipRef = useRef(null);

    const [isPending, startTransition] = useTransition();

    const HORAS = Array.from({ length: 24 }, (_, i) => `${String(i).padStart(2, "0")}:00`);

    const isFirstWeek = mondayStart && mondayBase.getTime() <= mondayStart.getTime();
    const isLastWeek =  mondayEnd && mondayBase.getTime() >= mondayEnd.getTime();

    const [selectedSlot, setSelectedSlot] = useState(null);
    // formato: { diaId: "20260413", hora: "08:00" }


    function getWeekRange(date = new Date()) {
    
        const day = date.getDay(); // 0 = domingo, 1 = segunda ...

        const monday = new Date(date);
        monday.setDate(date.getDate() - ((day + 6) % 7));

        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);

        return {monday, sunday};
    }

 
    function formatToFirestoreDate(date) {
        return date.toISOString().slice(0,10).replace(/-/g,"");
    }

    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {

        const loadBasic = async () => {
            
            const uid = auth.currentUser.uid;
            const bbd = await db_basic(uid);
            setBasic(bbd);
        
            //carrega informações
            try {


                

            } catch(erro) {

            }
        
        };

        loadBasic();

    }, []);


    useEffect(() => {if(!basic.agent?.id) return; carregarSemana(mondayBase)}, [mondayBase, basic.agent?.id]);


    useEffect(() => {
    
        if(!mondayBase || !basic.agent?.id) return;

        const diasSemanaIds = [];
        for(let i = 0; i < 7; i++) {
            const d = new Date(mondayBase);
            d.setDate(mondayBase.getDate() + i);
            diasSemanaIds.push(formatToFirestoreDate(d));
        }

        const aid = basic.agent.id;

        const logsRef = collection(db, "calendar_logs");
        const q = query(logsRef, where("id_agent", "==", aid), orderBy("date", "desc"));

        const unsubscribe = onSnapshot(q, (snapshot) => {

            snapshot.docChanges().forEach(change => {

            if(change.type !== "added") return;

            //proteção: pode vir change.doc undefined
            if(!change.doc || !change.doc.exists()) {
                console.warn("change.doc inexistente — ignorado");
                return;
            }

            const log = change.doc.data();

            let firestoreDia = log.dia;
            const hora = log.hora;
            const action = log.action;

            // normaliza o dia para YYYYMMDD
            if(firestoreDia.includes("-")) {
                firestoreDia = firestoreDia.replace(/-/g, "");
            } else if(firestoreDia.includes("/")) {
                const [dd, mm, yyyy] = firestoreDia.split("/");
                firestoreDia = `${yyyy}${mm.padStart(2, "0")}${dd.padStart(2, "0")}`;
            }

            if(!diasSemanaIds.includes(firestoreDia)) return;

            setSemana(prev => {
                
                const dias = [...prev];
                const idx = dias.findIndex(d => d.firestoreId === firestoreDia);
                
                if(idx === -1) return prev;

                const dia = {...dias[idx]};
                const horas = {...dia.horas};

                if(!horas[hora]) {
                    horas[hora] = { status: "nao_determinado" };
                }

                if(action === "ADD") {
                    horas[hora] = {
                        status: "ocupado",
                        paciente: {nome: log.nome || null, email: log.email || null, telefone: log.telefone || null, metadata: log.metadata || "", atendimento: log.atendimento || "", convenio: log.convenio || ""}
                    };
                }

                if(action === "CANCEL") {
                    horas[hora] = { status: "livre" };
                }

                dia.horas = horas;
                dias[idx] = dia;

                return dias;
                
            });

            });
        });

        return () => unsubscribe();

    }, [mondayBase, basic.agent?.id]);


    async function carregarSemana(mondayRef) {

        startTransition( async() => {

        try {

            let aid = basic.agent.id;
            let diasSemana = [];

            // busca a primeira e última semana REAL do calendário
            const diasRef = collection(db, "calendar", aid, "dias");
            const diasSnap = await getDocs(diasRef);

            const mondaySet = new Set();

            diasSnap.forEach(docSnap => {
                const date = firestoreIdToDate(docSnap.id); // YYYYMMDD → Date
                const monday = normalizeMonday(getMonday(date));
                mondaySet.add(formatToFirestoreDate(monday));
            });

            if (mondaySet.size === 0) {
                throw new Error("Nenhuma semana encontrada no calendário");
            }

            const mondays = Array.from(mondaySet).sort(); // string YYYYMMDD

            const firstMonday = firestoreIdToDate(mondays[0]);
            const lastMonday  = firestoreIdToDate(mondays[mondays.length - 1]);

            setMondayStart(firstMonday);
            setMondayEnd(lastMonday);

            // busca a segunda-feira
            const mondayId = formatToFirestoreDate(mondayRef);
            const mondayRefDb = doc(db, "calendar", aid, "dias", mondayId);
            const mondaySnap = await getDoc(mondayRefDb);

            if(!mondaySnap.exists()) {
                throw new Error("Segunda-feira não configurada no calendário");
            }

            const mondayData = mondaySnap.data();
            const interval = Number(mondayData.interval) || 60;
            setIntervalSemana(interval);

            const HORAS_SEMANA = gerarHorasUI(interval);

            // loop normal da semana
            for(let i = 0; i < 7; i++) {

                const d = new Date(mondayRef);
                d.setDate(mondayRef.getDate() + i);

                const firestoreId = formatToFirestoreDate(d);
                const ref = doc(db, "calendar", aid, "dias", firestoreId);
                const snap = await getDoc(ref);

                let horas = {};

                if(!snap.exists()) {

                    HORAS_SEMANA.forEach(h => {
                        horas[h] = { status: "nao_determinado" };
                    });

                } else {

                    const dados = snap.data();
                    const horariosDb = dados.horarios || {};

                    HORAS_SEMANA.forEach(h => {

                    if(!horariosDb[h]) {
                        horas[h] = { status: "nao_determinado" };
                        return;
                    }

                    const item = horariosDb[h];

                    if(item.status === "livre") {
                        horas[h] = { status: "livre" };
                        return;
                    }

                    if(item.status === "ocupado") {
                        horas[h] = {
                        status: "ocupado",
                        paciente: item.paciente || null
                        };
                        return;
                    }

                    if(item.status === "indisponivel") {
                        horas[h] = { status: "indisponivel" };
                        return;
                    }

                    horas[h] = { status: "nao_determinado" };
                    });

                }

                const dia_formatado = firestoreId.substring(6, 8) + "." + firestoreId.substring(4, 6) + "." + firestoreId.substring(0, 4);

                diasSemana.push({firestoreId, dia: dia_formatado, date: d, weekday: d.toLocaleDateString("pt-BR", { weekday: "long" }).replace("-feira", "").trim().replace(/^\w/, c => c.toUpperCase()), horas});
            }

            setSemana(diasSemana);
            console.log(diasSemana);
        }
        catch(erro) {

        }
        })

    }


    function getMonday(date) {
    
        const d = new Date(date);
        const day = d.getDay(); // 0 = domingo
        const diff = d.getDate() - day + (day === 0 ? -6 : 1);
        d.setDate(diff);
        d.setHours(0, 0, 0, 0);
        return d;

    }


    function normalizeMonday(date) {
        const d = new Date(date);
        d.setHours(0, 0, 0, 0);
        return d;
    }


    function firestoreIdToDate(id) {
        return new Date(id.substring(0, 4), Number(id.substring(4, 6)) - 1, id.substring(6, 8));
    }


    function proximaSemana() {

        if(isLastWeek) return;

        const nova = new Date(mondayBase);
        nova.setDate(nova.getDate() + 7);
        setMondayBase(normalizeMonday(nova));

    }


    function semanaAnterior() {

        if(isFirstWeek) return;
    
        const nova = new Date(mondayBase);
        nova.setDate(nova.getDate() - 7);
        setMondayBase(normalizeMonday(nova));
    
    }


    function buscarSemanaPorData(dataStr) {
    
        const [dia, mes, ano] = dataStr.split("/");
        const d = new Date(`${ano}-${mes}-${dia}`);

        const monday = new Date(d);
        const day = monday.getDay();
        const diff = (day === 0 ? -6 : 1 - day);
        monday.setDate(monday.getDate() + diff);

        setMondayBase(monday);
    
    }


    function TooltipAgendamento({data, tooltipRef}) {

        const [pos, setPos] = React.useState({ top: 0, left: 0 });

        React.useLayoutEffect(() => {
            if(!tooltipRef.current || !data?.rect) return;

            const tooltipWidth = tooltipRef.current.offsetWidth;
            const spacing = 8;

            const left = data.lado === "left" ? data.rect.left - tooltipWidth - spacing : data.rect.right + spacing;

            setPos({ top: data.rect.top, left });

        }, [data, tooltipRef]);

        if(!data?.paciente) return null;

        return (
            <div ref={tooltipRef} className="tooltip-agendamento" style={{ top: pos.top, left: pos.left }}>

            {data.paciente?.atendimento && (<div className="agenda-tooltip-atendimento" style={{backgroundColor: data.paciente.atendimento === "consulta" ? "blue" : data.paciente.atendimento === "retorno" ? "purple" : "green"}}>{ data.paciente.atendimento === "consulta" || data.paciente.atendimento === "retorno" ? data.paciente.atendimento.toUpperCase() : "EXAME: " + data.paciente.atendimento }</div>)}
            <span className="agenda-tooltip-space"></span>

            {data.paciente?.convenio && (<div className="tooltip-linha">{data.paciente.atendimento === "retorno" ? "" : data.paciente.convenio === "particular" ? "Particular" : "Convênio: " + data.paciente.convenio}</div>)}
            <span className="agenda-tooltip-space"></span>

            <strong>{data.paciente?.nome || "Paciente"}</strong>

            <div className="tooltip-linha">📅 {data.dia} — {data.hora}</div>

            {data.paciente?.email && (<div className="tooltip-linha">✉️ {data.paciente.email}</div>)}

            {data.paciente?.telefone && (<div className="tooltip-linha">📞 {data.paciente.telefone}</div>)}
            
            </div>
        );
    }



    function gerarHorasUI(interval) {

        const horas = [];
        let minutos = 0;

        while (minutos < 24 * 60) {
            const h = String(Math.floor(minutos / 60)).padStart(2, "0");
            const m = String(minutos % 60).padStart(2, "0");
            horas.push(`${h}:${m}`);
            minutos += interval;
        }

        return horas;
    }


    /* operações para alterar o calendário */
    const toggleLivreIndisponivel = async () => {

        //limpa erro anterior
        setErroAcao("");

        //nada selecionado
        if(!selectedSlot) {
            setErroAcao("selecione um dia/horário para executar isso");
            return;
        }

        //trava botão
        setIsUpdating(true);

        try {

            const { diaId, hora } = selectedSlot;

            const diaAtual = semana.find(d => d.firestoreId === diaId);
            const atual = diaAtual?.horas?.[hora];

            if(!atual) {
                throw new Error("Horário não encontrado");
            }

            //ocupado
            if(atual.status === "ocupado") {
                setErroAcao("Esse horário está ocupado.");
                return;
            }

            //define novo status
            let novoStatus;

            if(atual.status === "livre") {novoStatus = "indisponivel";} else {novoStatus = "livre";}

            //firestore
            const ref = doc(db, "calendar", basic.agent.id, "dias", diaId);

            await updateDoc(ref, {[`horarios.${hora}.status`]: novoStatus});

            setSemana(prev => prev.map(dia => {

                if(dia.firestoreId !== diaId) return dia;

                return {
                    ...dia,
                    horas: {
                        ...dia.horas,
                        [hora]: { status: novoStatus }
                    }
                };

            }));

        } catch (e) {
            setErroAcao("Erro ao atualizar.");
        } finally {
            setIsUpdating(false);
        }
    };



    const cancelarAgendamento = async () => {

        setErroAcao("");

        if(!selectedSlot) {
            setErroAcao("selecione um dia/horário para executar isso");
            return;
        }

        setIsUpdating(true);

        try {

            const { diaId, hora } = selectedSlot;

            const diaAtual = semana.find(d => d.firestoreId === diaId);
            const atual = diaAtual?.horas?.[hora];

            if(!atual) {
                throw new Error("Horário não encontrado");
            }

            //não está ocupado
            if(atual.status !== "ocupado") {
                setErroAcao("esse horário não possui agendamento");
                return;
            }

            //firestore
            const ref = doc(db, "calendar", basic.agent.id, "dias", diaId);

            await updateDoc(ref, {[`horarios.${hora}.status`]: "livre", [`horarios.${hora}.paciente`]: deleteField()});

            //state
            setSemana(prev => prev.map(dia => {

                if(dia.firestoreId !== diaId) return dia;

                return {
                    ...dia,
                    horas: {...dia.horas, [hora]: { status: "livre" }}
                };

            }));

        } catch (e) {
            setErroAcao("Erro ao cancelar agendamento.");
        } finally {
            setIsUpdating(false);
        }
    };



    function getMensagemAcao() {

        //prioridade máxima: erro
        if(erroAcao) return erroAcao;

        //nada selecionado
        if(!selectedSlot) {
            return "selecione um dia/horário para executar uma ação";
        }

        //selecionado → montar data
        const diaSelecionado = semana.find(d => d.firestoreId === selectedSlot.diaId);

        if(!diaSelecionado) return "";

        //transforma "09.04.2026" → "09/04/26"
        const [dd, mm, yyyy] = diaSelecionado.dia.split(".");
        const yy = yyyy.slice(-2);

        return `selecionado ${dd}.${mm}.${yy} ${selectedSlot.hora}`;
    
    }


    function getMensagemNavegar() {

        //prioridade máxima: erro
        if(erroNavegar) return erroNavegar;

        return ;
        
    }





    return(
        <div className="context">
        
            <Header access={1}></Header>
        
                <div className="content">
                    
                    <div className="ft_topico">Agenda</div>
                    <div className="ft_descricao">Esse é a sua agenda, aqui você pode visualizar e alterar todos os agendamentos que seus pacientes realizaram.</div>
                    <div className="space"></div>

                    <div className="schedule_filters_box">
                        <div className="schedule_filters_box1">{ isPending ? "carregando ..." : (<>Semana:&nbsp;<span style={{color: "var(--SEC_1)", letterSpacing: "1px"}}>{semana[0]?.dia}</span>&nbsp;a&nbsp;<span style={{color: "var(--SEC_1)", letterSpacing: "1px"}}>{semana[6]?.dia}</span></>) }</div>
                        <div className="schedule_filters_box2">
                            <div className="schedule_filters_box2_box">
                                <div className="schedule_filters_box2_space"></div>
                                <div className="schedule_filters_box2_botao">
                                    <CalendarCheck size={30} color={isUpdating ? "gray" : "orangered"} onClick={isUpdating ? null : toggleLivreIndisponivel} style={{cursor: isUpdating ? "not-allowed" : "pointer"}} />
                                    <span className="schedule_filters_box2_botao_text">{isUpdating ? "..." : "livre/indisp"}</span>
                                </div>
                                <div className="schedule_filters_box2_botao">
                                    <CalendarClock size={30} color="green" />
                                    <span className="schedule_filters_box2_botao_text">agendar</span>
                                </div>
                                <div className="schedule_filters_box2_botao">
                                    <CalendarX size={30} color={isUpdating ? "gray" : "red"} onClick={isUpdating ? null : cancelarAgendamento} style={{cursor: isUpdating ? "not-allowed" : "pointer"}} />
                                    <span className="schedule_filters_box2_botao_text">{isUpdating ? "..." : "cancelar"}</span>
                                </div>
                                <div className="schedule_filters_box2_botao">
                                    <CalendarSync size={30} color="blue" />
                                    <span className="schedule_filters_box2_botao_text">reagendar</span>
                                </div>
                                <div className="schedule_filters_box2_space"></div>
                            </div>
                            <span className="schedule_filters_box2_erro" style={{color: getMensagemAcao().substring(0, 11) === "selecionado" ? "var(--PRI_2)" : getMensagemAcao() === "selecione um dia/horário para executar isso" || getMensagemAcao() === "esse horário não possui agendamento" ? "red" : "var(--CNZ_2)"}}>{getMensagemAcao()}</span>
                        </div>
                        <div className="schedule_filters_box3">
                            <div className="schedule_filters_box3_box">
                                <div className="schedule_filters_box3_space"></div>
                                <div className="schedule_filters_box3_botao">
                                    <ArrowBigLeftDash size={30} color={isFirstWeek ? "var(--CNZ_3)" : "orangered"} onClick={() => {if(isFirstWeek) {setErroNavegar("você está na primeira semana"); return;} setErroNavegar(""); semanaAnterior();}} />
                                    <span className="schedule_filters_box2_botao_text">prox. semana</span>
                                </div>
                                <div className="schedule_filters_box3_botao">
                                    <ArrowBigRightDash size={30} color={isLastWeek ? "var(--CNZ_3)" : "orangered"} onClick={() => {if(isLastWeek) {setErroNavegar("você está na última semana"); return;} setErroNavegar(""); proximaSemana();}} />
                                    <span className="schedule_filters_box2_botao_text">semana ante.</span>
                                </div>
                                <div className="schedule_filters_box3_botao">
                                    <ClockArrowUp size={30} color="blue" />
                                    <span className="schedule_filters_box2_botao_text">buscar dia</span>
                                </div>
                                <div className="schedule_filters_box3_space"></div>
                            </div>
                            <span className="schedule_filters_box3_erro" style={{color: erroNavegar === "você está na primeira semana" || erroNavegar === "você está na última semana" ? "var(--PRI_2)" : "var(--CNZ_2)" }}>{erroNavegar ? erroNavegar : "navegue pelas semanas"}</span>
                        </div>
                    </div>

                    <div className="schedule_space"></div>

                    <div className="schedule_panel">
                        <div className="schedule_panel_hour">
                            <span className="schedule_panel_hour_title"></span>
                            {HORAS_UI.map(hora => (
                                <span key={hora} className="schedule_panel_hour_item">{hora}</span>
                            ))}
                        </div>
                        <div className="schedule_panel_space"></div>
                        <div className="schedule_panel_content">

                            {isPending ? (<><span className="schedule_loading">aguarde ...<br />carregando agenda</span></>) : 
                            (<>
                            
                            { semana.map((dia, index) => (
                            <div className="schedule_panel_box">
                                <span className="schedule_panel_day" data-short={semana[index]?.dia.substring(0, 5)}>{semana[index]?.dia}</span>
                                <span className="schedule_panel_weekday" data-short={semana[index]?.weekday.substring(0, 3)}>{semana[index]?.weekday}</span>
                                
                                { Object.entries(semana[index]?.horas || {}).map(([hora, info]) => {

                                    const isSelected = selectedSlot?.diaId === semana[index]?.firestoreId && selectedSlot?.hora === hora;
                                    
                                    return(
                                    <>
                                    <span className="schedule_panel_hourtohour" onClick={() => {setErroAcao(""); setSelectedSlot(prev => {if(prev?.diaId === semana[index]?.firestoreId && prev?.hora === hora) {return null;} return {diaId: semana[index]?.firestoreId, hora};});}} style={{fontSize: info.status === "nao_determinado" || info.status === "indisponivel" || info.status === "bloqueado" ? "0.7rem" : info.status === "livre" ? "1rem" : "0.8rem", backgroundColor: ((info.status === "nao_determinado" || info.status === "indisponivel") && semana[index]?.weekday.substring(0, 3) === "Sáb") ? "#f2f6ff" : ((info.status === "nao_determinado" || info.status === "indisponivel") && semana[index]?.weekday.substring(0, 3) === "Dom") ? "#fff2f2" : ((info.status === "nao_determinado" || info.status === "indisponivel") && semana[index]?.weekday.substring(0, 3) !== "Sáb" && semana[index]?.weekday.substring(0, 3) !== "Dom") ? "var(--HEAD_BK)" : info.status === "bloqueado" ? "var(--CNZ_4)" : info.status === "livre" ? "var(--SEC_4)" : "var(--PRI_4)", color: info.status === "nao_determinado" || info.status === "indisponivel" ? "var(--CNZ_3)" : info.status === "livre" ? "var(--SEC_1)" : info.status === "bloqueado" ? "var(--BAS_1)" : "var(--PRI_1)", cursor: info.status === "ocupado" ? "pointer" : "default", border: isSelected ? "2px solid #000" : "1px solid transparent", boxSizing: "border-box",}} onMouseEnter={(e) => {

                                        const rect = e.currentTarget.getBoundingClientRect();
                                        const weekday = semana[index]?.weekday;
                                        const ladoEsquerdo = weekday === "Sexta" || weekday === "Sábado" || weekday === "Domingo";

                                        setHoverAgendamento({paciente: info.paciente, hora, dia: semana[index]?.dia, rect, lado: ladoEsquerdo ? "left" : "right"});
                                    
                                    }} data-short={info.status === "nao_determinado" || info.status === "indisponivel" ? "-" : info.status === "livre" || info.status === "bloqueado" ? "livre" : "ver"}>{info.status === "nao_determinado" || info.status === "indisponivel" ? "não disponível" : info.status === "livre" || info.status === "bloqueado" ? info.status : info.paciente?.nome || ""}</span>
                                    </>
                                    ); 
                                })}

                            </div>
                            ))}

                            </>)}

                        </div>
                    </div>

                    {hoverAgendamento?.paciente && (<TooltipAgendamento data={hoverAgendamento} tooltipRef={tooltipRef}/>)}

                    <div className="space"></div>
                    <span className="schedule_observacao">Obs.: Você pode alterar seu calendário de acordo com todas as funcionalidades acima. Ou para alterar apenas as disponibilidades você também pode acessar:<br />Painel do Cliente &#8594; Alterar Agente &#8594; Alterar Configurações &#8594; Passo 4 - Calendário</span>
                    <div className="space_form"></div>
                    <span className="schedule_observacao">ou</span>
                    <div className="space_form"></div>
                    <Link className="schedule_link_agenda" to="/medical" state={{step: 3}}>ALTERAR AGENDA</Link>

                <div className="space"></div>
                <div className="space"></div>
                <div className="button_back_form"><button type="button" name="btbck" className="button2_form" onClick={() => navigate("/panel")}>VOLTAR</button></div>
                <div className="space"></div>
                <div className="space"></div>
                        
                </div>
                        
            <Footer access={1}></Footer>
                        
        </div>
    )
}